/* mx-lista — Compra por Lista (MoxLand) */
(function () {
  if (window.__mxListaInit) return;
  window.__mxListaInit = true;
  var raiz = document.querySelector('[data-mx-lista]');
  if (!raiz) return;

  var FATIAS = JSON.parse(raiz.getAttribute('data-fatias'));
  var UG = raiz.getAttribute('data-arq-g') || '';
  var dados = null, linhas = [], carregando = false;

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9 ]+/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }
  function el(q) { return raiz.querySelector(q); }
  function dinheiro(v) {
    return 'R$ ' + (Number(v) || 0).toFixed(2).replace('.', ',');
  }
  function status(t) { el('[data-mx-status]').textContent = t || ''; }

  function carregar() {
    if (dados) return Promise.resolve();
    status('Carregando catálogo (só na primeira vez)...');
    var lista = FATIAS.slice();
    if (UG) lista.push(UG);
    return Promise.all(lista.map(function (u) {
      return fetch(u).then(function (r) { return r.json(); })
        .catch(function () { return []; });
    })).then(function (partes) {
      dados = [];
      for (var i = 0; i < FATIAS.length; i++) {
        partes[i].forEach(function (c) {
          dados.push({
            pt: c[0], en: c[1], set: c[2], num: c[3],
            preco: c[8], precoF: c[9], est: c[10], estF: c[11],
            handle: c[12], vid: c[14], vidF: c[15],
            extras: (c[16] || []),
            jogo: 'Magic',
            npt: norm(c[0]), nen: norm(c[1])
          });
        });
      }
      (partes[FATIAS.length] || []).forEach(function (p) {
        dados.push({
          pt: p[0], en: p[0], set: p[5] || '', num: '',
          preco: p[2], precoF: 0, est: p[3], estF: 0,
          handle: p[4], vid: p[6], vidF: '',
          jogo: p[1] || '',
          npt: norm(p[0]), nen: norm(p[0])
        });
      });
      status('');
    });
  }

  /* ---- interpretar uma linha da lista ---- */
  function lerLinha(txt) {
    var t = txt.trim();
    if (!t) return null;
    var qtd = 1, nome = t, ed = '';
    var m = t.match(/^(\d+)\s*[xX]?\s+(.*)$/);
    if (m) { qtd = parseInt(m[1], 10); nome = m[2]; }
    else {
      m = t.match(/^(.*?)\s*[xX]\s*(\d+)$/);
      if (m) { nome = m[1]; qtd = parseInt(m[2], 10); }
    }
    var me = nome.match(/^(.*?)\s*[\(\[]([^\)\]]+)[\)\]]\s*(.*)$/);
    if (me) { nome = me[1]; ed = me[2]; }
    nome = nome.replace(/\s+\d+\s*$/, '').trim();
    if (!nome) return null;
    return { qtd: Math.max(1, Math.min(qtd, 99)),
             nome: nome, ed: ed, original: t };
  }

  /* ---- achar a carta ---- */
  function achar(pedido) {
    var alvo = norm(pedido.nome);
    if (!alvo) return [];
    var exatos = dados.filter(function (c) {
      return c.npt === alvo || c.nen === alvo;
    });
    if (!exatos.length) {
      exatos = dados.filter(function (c) {
        return c.npt.indexOf(alvo) === 0 || c.nen.indexOf(alvo) === 0;
      });
    }
    if (!exatos.length) {
      exatos = dados.filter(function (c) {
        return c.npt.indexOf(alvo) >= 0 || c.nen.indexOf(alvo) >= 0;
      }).slice(0, 60);
    }
    if (pedido.ed) {
      var ne = norm(pedido.ed);
      var so = exatos.filter(function (c) {
        return norm(c.set).indexOf(ne) >= 0 ||
               (c.set || '').toLowerCase() === ne;
      });
      if (so.length) exatos = so;
    }
    return exatos;
  }

  function versoes(c) {
    var v = [];
    if (c.vid && c.preco > 0) {
      v.push({ vid: c.vid, preco: c.preco, est: c.est,
               rotulo: 'Normal', c: c });
    }
    if (c.vidF && c.precoF > 0) {
      v.push({ vid: c.vidF, preco: c.precoF, est: c.estF,
               rotulo: 'Foil', c: c });
    }
    /* acabamentos especiais COM estoque, com o rotulo VERDADEIRO
       (Silver Scroll, Surge Foil, Etched...). Vazio na maioria. */
    (c.extras || []).forEach(function (x) {
      if (!x || !(Number(x[2]) > 0) || !x[3]) return;
      v.push({ vid: x[3], preco: Number(x[1] || 0),
               est: Number(x[2]), rotulo: String(x[0] || ''), c: c });
    });
    return v;
  }

  function melhor(cands) {
    var todas = [];
    cands.forEach(function (c) {
      versoes(c).forEach(function (v) { todas.push(v); });
    });
    var comEst = todas.filter(function (v) { return v.est > 0; });
    var alvo = comEst.length ? comEst : todas;
    alvo.sort(function (a, b) { return a.preco - b.preco; });
    return { escolhida: alvo[0] || null, todas: todas };
  }

  /* ---- montar a tabela ---- */
  function processar() {
    var texto = el('[data-mx-texto]').value || '';
    linhas = [];
    texto.split(/\r?\n/).forEach(function (t) {
      var pedido = lerLinha(t);
      if (!pedido) return;
      var cands = achar(pedido);
      var r = melhor(cands);
      linhas.push({
        pedido: pedido,
        opcoes: r.todas,
        escolhida: r.escolhida,
        achou: !!r.escolhida
      });
    });
    desenhar();
  }

  function desenhar() {
    var corpo = el('[data-mx-tabela] tbody');
    corpo.innerHTML = '';
    var total = 0, itens = 0, faltando = 0, naoAchou = 0;
    linhas.forEach(function (ln, i) {
      var tr = document.createElement('tr');
      if (!ln.achou) {
        naoAchou++;
        tr.innerHTML = '<td>' + ln.pedido.qtd + '</td>' +
          '<td colspan="4" class="mx-erro">' +
          'Não encontrado: <strong>' + ln.pedido.original +
          '</strong></td>';
        corpo.appendChild(tr);
        return;
      }
      var v = ln.escolhida;
      var qtd = Math.min(ln.pedido.qtd, Math.max(v.est, 0));
      if (qtd < ln.pedido.qtd) faltando++;
      total += qtd * v.preco;
      itens += qtd;
      var sel = '<select class="field__input" ' +
        'data-mx-opcao="' + i + '">';
      ln.opcoes.forEach(function (o, j) {
        sel += '<option value="' + j + '"' +
          (o === v ? ' selected' : '') + '>' +
          (o.c.set || o.c.jogo) + ' — ' + o.rotulo + ' — ' +
          dinheiro(o.preco) +
          (o.est > 0 ? ' (' + o.est + ')' : ' (esgotado)') +
          '</option>';
      });
      sel += '</select>';
      tr.innerHTML =
        '<td><input type="number" min="1" max="99" ' +
          'class="field__input" value="' + ln.pedido.qtd +
          '" data-mx-qtd="' + i + '"></td>' +
        '<td><a href="/products/' + v.c.handle +
          '" target="_blank">' + v.c.pt + '</a></td>' +
        '<td>' + sel + '</td>' +
        '<td>' + dinheiro(v.preco) + '</td>' +
        '<td>' + (qtd === 0
          ? '<span class="mx-erro">esgotado</span>'
          : (qtd < ln.pedido.qtd
              ? '<span class="mx-aviso">só ' + qtd + '</span>'
              : dinheiro(qtd * v.preco))) + '</td>';
      corpo.appendChild(tr);
    });
    el('[data-mx-resumo]').innerHTML =
      '<strong>' + itens + '</strong> cards · total <strong>' +
      dinheiro(total) + '</strong>' +
      (faltando ? ' · <span class="mx-aviso">' + faltando +
        ' com estoque parcial</span>' : '') +
      (naoAchou ? ' · <span class="mx-erro">' + naoAchou +
        ' não encontrados</span>' : '');
    el('[data-mx-add]').style.display = itens ? '' : 'none';
  }

  /* ---- carrinho ---- */
  function adicionar() {
    var itens = [];
    linhas.forEach(function (ln) {
      if (!ln.achou) return;
      var v = ln.escolhida;
      var qtd = Math.min(ln.pedido.qtd, Math.max(v.est, 0));
      if (qtd > 0) itens.push({ id: Number(v.vid), quantity: qtd });
    });
    if (!itens.length) return;
    el('[data-mx-add]').disabled = true;
    status('Adicionando ao carrinho...');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itens })
    }).then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) throw res;
        status('');
        window.location.href = '/cart';
      }).catch(function (e) {
        el('[data-mx-add]').disabled = false;
        status('Não consegui adicionar: ' +
          ((e && (e.description || e.message)) || 'erro'));
      });
  }

  /* ---- eventos ---- */
  el('[data-mx-conferir]').addEventListener('click', function () {
    if (carregando) return;
    carregando = true;
    carregar().then(function () {
      carregando = false;
      processar();
    });
  });
  el('[data-mx-add]').addEventListener('click', adicionar);
  raiz.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute && t.hasAttribute('data-mx-opcao')) {
      var i = Number(t.getAttribute('data-mx-opcao'));
      linhas[i].escolhida = linhas[i].opcoes[Number(t.value)];
      desenhar();
    } else if (t.hasAttribute && t.hasAttribute('data-mx-qtd')) {
      var j = Number(t.getAttribute('data-mx-qtd'));
      linhas[j].pedido.qtd = Math.max(1, Number(t.value) || 1);
      desenhar();
    }
  });
  el('[data-mx-limpar]').addEventListener('click', function () {
    el('[data-mx-texto]').value = '';
    linhas = [];
    desenhar();
  });
})();
